"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _queryList = _interopRequireDefault(require("@/components/queryList"));
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    QueryList: _queryList.default
  },
  data: function data() {
    return {
      pageName: 'gasnSign',
      searchQuery: {
        storeCode: '',
        storeName: '',
        signTimeMix: '',
        signTimeMax: '',
        signEndTimMix: '',
        signEndTimeMax: ''
      },
      apiModule: 'kpiSet'
    };
  },
  computed: {
    domData: function domData() {
      return {
        storeCode: {
          label: this.$t('sfe.GASNSign.storeCode'),
          valueKey: 'storeCode'
        },
        storeName: {
          label: this.$t('sfe.GASNSign.storeName'),
          valueKey: 'storeName'
        },
        signTimeMix: {
          label: this.$t('sfe.GASNSign.signTimeMix'),
          valueKey: 'signTimeMix',
          inputType: 'date',
          type: 'date',
          valueFormat: 'yyyy-MM-dd'
        },
        signTimeMax: {
          label: this.$t('sfe.GASNSign.signTimeMax'),
          valueKey: 'signTimeMax',
          inputType: 'date',
          type: 'date',
          valueFormat: 'yyyy-MM-dd'
        },
        signEndTimMix: {
          label: this.$t('sfe.GASNSign.signEndTimMix'),
          valueKey: 'signEndTimMix',
          inputType: 'date',
          type: 'date',
          valueFormat: 'yyyy-MM-dd'
        },
        signEndTimeMax: {
          label: this.$t('sfe.GASNSign.signEndTimeMax'),
          valueKey: 'signEndTimeMax',
          inputType: 'date',
          type: 'date',
          valueFormat: 'yyyy-MM-dd'
        }
      };
    },
    tableButtons: function tableButtons() {
      return {
        export: {
          fileName: this.$t('sfe.route.gasnsign'),
          apiUrl: '/protected/retailorStoreSignInfo/export'
        },
        import: {
          apiUrl: '/protected/retailorStoreSignInfo/import'
        }
      };
    },
    tableDom: function tableDom() {
      return {
        storeCode: {
          label: this.$t('sfe.GASNSign.storeCode')
        },
        storeName: {
          label: this.$t('sfe.GASNSign.storeName')
        },
        signTime: {
          label: this.$t('sfe.GASNSign.signTime')
        },
        signEndTime: {
          label: this.$t('sfe.GASNSign.signEndTime')
        }
      };
    },
    listApi: function listApi() {
      return {
        apiUrl: '/protected/retailorStoreSignInfo/list'
      };
    }
  }
};